import { useCallback, useMemo } from "react";
import type { FiatPrice } from "@b2bportal/core-types";
import type { Dayjs } from "dayjs";
import { useEnhancedEarnAmount } from "../../../hooks/shared";
import { openNubankWallet } from "../../../utils/nubankHandoff";
import { EnhancedEarnRow } from "../../EnhancedEarn";
import {
  type AnyPaymentBreakdown,
  isNubankCreditPayment,
} from "./creditPayment";
import styles from "./styles.module.scss";

export const TripsFlightsPaymentDetailsAdditionalInfo = ({
  totalPrice,
  dateBooked,
  paymentBreakdown,
}: {
  totalPrice: FiatPrice;
  dateBooked: Dayjs;
  paymentBreakdown?: AnyPaymentBreakdown;
}) => {
  const { isEnhancedEarnEnabled, isBookingAfterLaunch } =
    useEnhancedEarnAmount();

  const isCreditCardPayment = useMemo(
    () => isNubankCreditPayment(paymentBreakdown),
    [paymentBreakdown]
  );

  const openWallet = useCallback(() => {
    openNubankWallet();
  }, []);

  return (
    <div className={styles.TripsFlightsPaymentDetailsAdditionalInfo}>
      {isEnhancedEarnEnabled &&
      isCreditCardPayment &&
      isBookingAfterLaunch(dateBooked) ? (
        <EnhancedEarnRow
          totalPrice={totalPrice.value}
          hasLearnMore
          onClick={openWallet}
        />
      ) : null}
    </div>
  );
};
